var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSternAktiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stern-Aktiv__Icn/40px/Stern-Aktiv",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stern-Aktiv__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stern-Aktiv__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Stern-Aktiv__Path",
    d: "M20 9 23.2328189 15.5504065 30.4616217 16.6008131 25.2308108 21.6995935 26.4656378 28.8991869 20 25.5 13.5343622 28.8991869 14.7691892 21.6995935 9.53837832 16.6008131 16.7671811 15.5504065z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSternAktiv);
export default __webpack_public_path__ + "static/media/Stern-Aktiv.cf52264029eb6865bae40c01b9f42079.svg";
export { ForwardRef as ReactComponent };